<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    // console.log("parent-------", window.parent);
    parent.window.postMessage('{"type":"closeDownLoadErrorDialog"}', "*");
  },
};
</script>
<style lang="scss" scoped></style>
